/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#konten[_ngcontent-%COMP%]{margin:10px}.portlet-blue[_ngcontent-%COMP%]{background-color:#2f353b}.portlet-blue[_ngcontent-%COMP%]   .kt-portlet__head-title[_ngcontent-%COMP%]{color:#fff}"];
export { styles as styles };
